import { AppService } from 'voc-service'
const appService = new AppService()
appService.register({
  env: process.env.VUE_APP_ENV,
  appName: 'hotelcem',
})
